import { t } from '@lingui/core/macro';
import { Alert } from '@pocketlaw/tetris';
import { AlertContainer } from './styled';
export function LoadingProviderErrorState() {
    return (<AlertContainer>
      <Alert appearance="danger" message={t({
            message: 'Something went wrong, please try again later',
            comment: 'Error message for not being able to load the current e-signing provider',
        })}/>
    </AlertContainer>);
}
